var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _rect;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFoodAndBeverage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5217 37.3066C19.7353 33.3885 23.6516 30.7559 26.9359 27.6794C30.0525 24.7599 32 20.6074 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 20.6074 1.94745 24.7599 5.06412 27.6794C8.34841 30.7559 12.2647 33.3885 14.4783 37.3066L15.5647 39.2295C15.7561 39.5682 16.2439 39.5682 16.4353 39.2295L17.5217 37.3066Z",
    fill: "#4B4B4B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 7C15.625 6.44772 15.1773 6 14.625 6C14.0727 6 13.625 6.44772 13.625 7H15.625ZM10 7C10 6.44772 9.55228 6 9 6C8.44772 6 8 6.44772 8 7H10ZM13.625 7V13.1875H15.625V7H13.625ZM10 13.1875V7H8V13.1875H10ZM11.8125 15C10.8115 15 10 14.1885 10 13.1875H8C8 15.2931 9.70691 17 11.8125 17V15ZM13.625 13.1875C13.625 14.1885 12.8135 15 11.8125 15V17C13.9181 17 15.625 15.2931 15.625 13.1875H13.625Z",
    fill: "#4B4B4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 24.55C11.8125 20.95 11.8125 16 11.8125 16",
    stroke: "#4B4B4B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 12.5V7",
    stroke: "#4B4B4B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5H14",
    stroke: "#4B4B4B",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 24.5V7.16251C22 7.0873 21.9214 7.03796 21.8537 7.07066V7.07066C20.1088 7.91311 19 9.67977 19 11.6173V17.0093H21.5",
    fill: "#4B4B4B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24.5C21 25.0523 21.4477 25.5 22 25.5C22.5523 25.5 23 25.0523 23 24.5H21ZM19 17.0093H18C18 17.5616 18.4477 18.0093 19 18.0093V17.0093ZM21.5 18.0093C22.0523 18.0093 22.5 17.5616 22.5 17.0093C22.5 16.457 22.0523 16.0093 21.5 16.0093V18.0093ZM23 24.5V7.16251H21V24.5H23ZM18 11.6173V17.0093H20V11.6173H18ZM19 18.0093H21.5V16.0093H19V18.0093ZM21.4189 6.17013C19.3284 7.17944 18 9.296 18 11.6173H20C20 10.0635 20.8892 8.64678 22.2885 7.97119L21.4189 6.17013ZM23 7.16251C23 6.34997 22.1506 5.81683 21.4189 6.17013L22.2885 7.97119C21.6922 8.25909 21 7.82464 21 7.16251H23Z",
    fill: "#4B4B4B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    width: 4,
    height: 2,
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFoodAndBeverage);
export default __webpack_public_path__ + "static/media/icon_food-and-beverage.d8433c29981c618448a735a9fc7d2966.svg";
export { ForwardRef as ReactComponent };